import { connect } from "react-redux";
import React, { Component } from "react";
import "swiper/dist/css/swiper.css";
import "./SubscribeComponent.scss";
import wallpaper from "../../assets/images/logo.png";
import {
  billingResetPasswordForm,
  billingForgotPasswordForm
} from "../../actions/vas";
import ModalERROR from "../Modals/ModalERROR";
import { vasError } from "../../actions/modals";
import { APP_MESSAGES } from "../../services/config/messages";
import {
  validateEmail,
  validateMsisdn,
  validatePassword,
  validateNumber
} from "../../utils/validators";
import { withTranslation, Trans } from "react-i18next";
import i18n from "../../i18n";
import { lang } from "moment";

class BillingResetPasswordComponent extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}

  render() {
    let ErrorPhoneNum;
    let ErrorPassword;
    let ErrorRePassword;
    ErrorPhoneNum = this.props.billingResetPasswordForm.fields.otp.errorMsg
      ? APP_MESSAGES[this.props.billingResetPasswordForm.fields.otp.errorMsg](
          this.props.billingResetPasswordForm.fields.otp.errorPayload,
          () => {
            this.props.billingResetPasswordFormResetError("otp");
          }
        )
      : props => <>{""}</>;

    ErrorPassword = this.props.billingResetPasswordForm.fields.password.errorMsg
      ? APP_MESSAGES[
          this.props.billingResetPasswordForm.fields.password.errorMsg
        ](
          this.props.billingResetPasswordForm.fields.password.errorPayload,
          () => {
            this.props.billingResetPasswordFormResetError("password");
          }
        )
      : props => <>{""}</>;

    ErrorRePassword = this.props.billingResetPasswordForm.fields.repassword
      .errorMsg
      ? APP_MESSAGES[
          this.props.billingResetPasswordForm.fields.repassword.errorMsg
        ](
          this.props.billingResetPasswordForm.fields.repassword.errorPayload,
          () => {
            this.props.billingResetPasswordFormResetError("repassword");
          }
        )
      : props => <>{""}</>;
    const { t } = this.props;
    const lang = i18n.language;
    return (
      <>
        <ModalERROR
          handleHide={() => {
            this.props.vasClose();
            this.props.billingResetPasswordFormResetError("otp");
            this.props.billingResetPasswordFormResetError("password");
            this.props.billingResetPasswordFormResetError("repassword");
          }}
          isOpen={this.props.isVasErrorModalOpen}
        >
          <ErrorPhoneNum />
          <ErrorPassword />
          <ErrorRePassword />
        </ModalERROR>
        <section className="billing-background">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7 ">
                <div className="row d-flex flex-column height-fixed px-0 px-lg-3">
                  <div className="col-auto d-flex justify-content-center">
                    <div className="logo-wrapper bg-black-transparent d-flex align-items-center px-4">
                      <a href={"/" + lang}>
                        {" "}
                        <img src={wallpaper} className="img-fluid" alt="" />
                      </a>
                    </div>
                  </div>
                  <div className="col bg-white text-center pl-3 pl-lg-5  pr-3 pr-lg-5 pt-2 pt-lg-4 overflow-auto">
                    <div className="row">
                      <div className="col-sm-12">
                        <p className="bold font-size-30">{t("resetArcadeX")}</p>
                      </div>
                    </div>
                    <form
                      onSubmit={e => {
                        e.preventDefault();
                        if (!this.props.billingResetPasswordForm.isSubmitting) {
                          if (
                            !this.props.billingResetPasswordForm.fields.otp
                              .value
                          ) {
                            this.props.billingResetPasswordFormSetError(
                              "otp",
                              "VAS_NOT_EMPTY"
                            );
                            this.props.vasError();
                            return false;
                          }

                          if (
                            !this.props.billingResetPasswordForm.fields.password
                              .value
                          ) {
                            this.props.billingResetPasswordFormSetError(
                              "password",
                              "VAS_NOT_EMPTY"
                            );
                            this.props.vasError();
                            return false;
                          }

                          if (
                            !validatePassword(
                              this.props.billingResetPasswordForm.fields
                                .password.value
                            )
                          ) {
                            this.props.billingResetPasswordFormSetError(
                              "password",
                              "VAS_PASSWORD_LENGTH"
                            );
                            this.props.vasError();
                            return false;
                          }

                          if (
                            !this.props.billingResetPasswordForm.fields
                              .repassword.value
                          ) {
                            this.props.billingResetPasswordFormSetError(
                              "repassword",
                              "VAS_NOT_EMPTY"
                            );
                            this.props.vasError();
                            return false;
                          }

                          if (
                            this.props.billingResetPasswordForm.fields.password
                              .value !==
                            this.props.billingResetPasswordForm.fields
                              .repassword.value
                          ) {
                            this.props.billingResetPasswordFormSetError(
                              "password",
                              "COMPARE_PASSWORD"
                            );
                            this.props.vasError();
                            return false;
                          }

                          let postParam = {
                            otp: this.props.billingResetPasswordForm.fields.otp
                              .value,
                            otpToken: this.props.billingForgotPasswordForm
                              .fields.otptoken.value,
                            password: this.props.billingResetPasswordForm.fields
                              .password.value
                          };
                          this.props.billingResetPasswordFormSubmit(postParam);
                        }
                      }}
                    >
                      <div className="box">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group mb-2 has-warning">
                              <label className="lable bold font-size-21">
                                {t("enterOtp")}
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                placeholder={t("placeOtp")}
                                onChange={event => {
                                  this.props.billingResetPasswordFormUpdateField(
                                    "otp",
                                    event.target.value
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="form-group mb-2 has-warning">
                              <label className="lable bold font-size-21">
                                {t("createPassword")}
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                placeholder={t("placeNewPassword")}
                                onChange={event => {
                                  this.props.billingResetPasswordFormUpdateField(
                                    "password",
                                    event.target.value
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 mb-3">
                            <div className="form-group mb-2 has-warning">
                              <label className="lable bold font-size-21">
                                {t("repassword")}
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                placeholder={t("placeRePassword")}
                                onChange={event => {
                                  this.props.billingResetPasswordFormUpdateField(
                                    "repassword",
                                    event.target.value
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-12 mt-3 mt-lg-4 custom-padding">
                          <button
                            type="submit"
                            className={
                              "btn btn-primary py-2 py-lg-3 btn-block rounded-pill font-size-24 bold text-shadow " +
                              (this.props.billingResetPasswordForm.isSubmitting
                                ? " disabled"
                                : "")
                            }
                          >
                            {t("Confirm")}
                          </button>
                        </div>
                        <div className="col-sm-12">
                          <h3 className="text-charcole-light bold font-size-21 mt-2 mt-lg-3">
                            <spna
                              onClick={() => {
                                let postParam = {
                                  phoneNumber: this.props
                                    .billingForgotPasswordForm.fields
                                    .phonenumber.value,
                                  mondiaCountryId: this.props
                                    .billingForgotPasswordForm.fields
                                    .mondiaCountryId.value
                                };
                                this.props.billingForgotPasswordFormSubmit(
                                  postParam
                                );
                              }}
                              className="text-charcole-light a"
                            >
                              {t("resend")}{" "}
                            </spna>
                          </h3>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 mt-3 mt-lg-4">
                            <div className="blank-space"></div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

const mapDispatchToProps = {
  billingResetPasswordFormSubmit: billingResetPasswordForm.submit,
  billingResetPasswordFormReset: billingResetPasswordForm.reset,
  billingResetPasswordFormResetField: billingResetPasswordForm.resetField,
  billingResetPasswordFormUpdateField: billingResetPasswordForm.updateField,
  billingResetPasswordFormSetError: billingResetPasswordForm.setError,
  billingResetPasswordFormSetSuccess: billingResetPasswordForm.setSuccess,
  billingResetPasswordFormResetError: billingResetPasswordForm.resetError,
  billingResetPasswordFormResetSuccess: billingResetPasswordForm.resetSuccess,
  vasError: vasError.open,
  vasClose: vasError.close,
  billingForgotPasswordFormSubmit: billingForgotPasswordForm.submit
};

const mapStateToProps = state => {
  return {
    billingResetPasswordForm: state.vas_blacklist.billingresetpasswordform,
    billingForgotPasswordForm: state.vas.billingforgotpasswordform,
    billingSubscriptionForm: state.vas.billingsubscriptionform,
    isVasErrorModalOpen: state.modals.isVasErrorModalOpen
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(BillingResetPasswordComponent));
